<template>
    <div class="sub-container">
      <div class="form-row-input">
        <ejs-autocomplete
          id="siteIdField"
          ref="siteNumber"
          float-label-type="Always"
          :dataSource="siteDataSource"
          :placeholder="siteNumberPlaceholder"
          :allowFiltering="true"
          filterType="StartsWith"
          :fields="siteNumberFields"
          @change="updateSite"
          :value="site.siteId"
          :maxlength="250"
        />
      </div>

      <div class="form-row-input" style="grid-column: span 2">
        <ejs-autocomplete
          ref="addressField"
          :dataSource='sitesSearchDataSource'
          :placeholder="searchAddressPlaceholder"
          data-test-address-info="saddr"
          :fields="addressFields"
          sortOrder="Ascending"
          filterType="Contains"
          float-label-type="Always"
          @change="onSiteSelection"
          :value="addressId"
          width = "100%"
        >
        </ejs-autocomplete>
      </div>

      <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          :placeholder="siteNamePlaceholder"
          v-model="site.siteName"
          data-test-address-info="cmp"
          :maxlength="250"
        />
      </div>

      <div class="form-row-input">
        <ejs-autocomplete
          ref="addressAutoComplete"
          data-test-address-info="addr"
          :dataSource="melissaAddresses"
          :placeholder="siteAddressPlaceholder"
          :fields="addressAutocompleteFields"
          float-label-type="Always"
          @change="onAddressSelection"
          :filtering="onAddressAutocompleteFiltering"
          :value="company.address"
          :maxlength="250"
        />
      </div>

      <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="City/Town:"
          data-test-address-info="ct"
          v-model="company.cityName"
          :maxlength="250"
        />
      </div>

      <div class="form-row-input">
        <ejs-dropdownlist
          sortOrder="Ascending"
          :allowFiltering="true"
          float-label-type="Always"
          :dataSource="provinces"
          placeholder="Province:"
          data-test-address-info="prv"
          :fields="companyProvinceFields"
          v-model="company.provinceName"
          :maxlength="250"
        />
      </div>

      <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="Postal Code/Zip:"
          data-test-address-info="pc"
          v-model="company.postalCode"
          :maxlength="10"
        />
      </div>
      <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="Municipality:"
          :value="municipality"
          :readOnly="true"
          class="readOnlyField"
          :maxlength="250"
        />
     </div>
      <div class="form-row-input">
        <ejs-dropdownlist
          v-if="showCountryField"
          :fields="companyCountriesFields"
          float-label-type="Always"
          sortOrder="Ascending"
          :dataSource="countries"
          placeholder="Country:"
          data-test-address-info="cnt"
          v-model="company.countryName"
          :maxlength="250"
        />
      </div>
    </div>
  </template>
<script>
import { mapActions, mapGetters } from 'vuex';
// import { applierTypeEnum } from '../constants';
import { GET_MELISSA_ADDRESSES } from '../../../user-accounts/store';
import { getEServicesContacts } from '../../../auth/services/tms-api';

export default {
  name: 'SiteInfo',

  props: {
    applier: String,
    sites: Array,
    showCountryField: Boolean,
    company: Object,
    site: Object,
    siteNumberFields: Object,
    siteDataSource: Array,
    siteNumberPlaceholder: String,
    municipality: String,
    companySearchType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      companyProvinceFields: {
        text: 'provinceName',
        value: 'provinceName',
        groupBy: 'countryName',
      },
      companyCountriesFields: { text: 'countryName', value: 'countryName' },
      addressAutocompleteFields: { value: 'Address.Address' },
      melissaCountry: 'CA',
    };
  },

  computed: {
    ...mapGetters({
      provinces: 'provinces',
      companies: 'companies',
      countries: 'countries',
      melissaAddresses: 'melissaAddresses',
      // permit: 'permit',
    }),

    siteAddressPlaceholder() {
      return 'Site Address:';
    },

    siteNamePlaceholder() {
      return 'Site Name: ';
    },

    searchAddressPlaceholder() {
      return '(Search) Site: ';
    },

    sitesSearchDataSource() {
      return this.sites;
    },

    addressFields() {
      return { value: 'site_Address_For_Search' };
    },
    addressId: {
      get() {
        return this.site.siteName ? `${this.site.siteName ? this.site.siteName : ''},${this.company.address ? this.company.address : ''}, ${this.company.cityName ? this.company.cityName : ''}, ${this.company.countryName ? this.company.countryName : ''}` : '';
      },
      set(val) {
        return val;
      },
    },
  },
  mounted() {
    this.refreshSiteNumber();
  },

  methods: {
    ...mapActions({
      fetchMellisaAddresses: GET_MELISSA_ADDRESSES,
    }),

    onAddressSelection(e) {
      if (e.e) {
        const { itemData } = e;
        if (itemData) {
          const selectedAddress = itemData.Address;
          if (selectedAddress.Address1) {
            this.company.address = selectedAddress.Address1;
          } else {
            this.company.address = selectedAddress.Address;
          }
          if (selectedAddress.Locality || selectedAddress.SubAdministrativeArea) {
            this.company.cityName = selectedAddress.Locality
              || selectedAddress.SubAdministrativeArea;
          }
          if (selectedAddress.AdministrativeArea) {
            this.company.provinceName = this.provinces.find(
              (x) => x.provinceCode === selectedAddress.AdministrativeArea,
            ).provinceName;
          }
          if (selectedAddress.PostalCode) {
            this.company.postalCode = selectedAddress.PostalCode;
          }
          if (selectedAddress.CountryName) {
            this.company.countryName = selectedAddress.CountryName.toLowerCase().startsWith('united')
              ? 'United States'
              : 'Canada';
          }
        }
      }
    },

    async onSiteSelection(e) {
      if (e.e) {
        const { itemData } = e;
        const value = itemData && itemData.sourceCompanyId ? itemData.sourceCompanyId : '';
        this.$emit(
          'updateSite',
          itemData || null,
        );
        this.refreshSiteNumber();

        if (value) {
          const contactResp = await getEServicesContacts(value);
          const contact = contactResp.data;
          // eslint-disable-next-line no-return-assign, no-param-reassign
          contact.forEach((x) => (x.name = `${x.fName} ${x.lName}`));
          this.$emit('updateContactFieldDS', contact);
        } else {
          this.$emit('updateContactFieldDS', null);
        }
      }
    },
    async onAddressAutocompleteFiltering(e) {
      e.preventDefaultAction = true;
      const enteredText = e.text;
      if (enteredText.length >= 3) {
        this.$refs.addressAutoComplete.ej2Instances.showSpinner();
        await this.fetchMellisaAddresses({
          melissaAddress1: enteredText,
          melissaCountry: this.melissaCountry,
        });
        e.updateData(this.melissaAddresses);
      }
    },
    refreshSiteNumber() {
      // enforce to update site/owner number
      const siteRef = this.$refs && this.$refs.siteNumber ? this.$refs.siteNumber.$el : null;
      if (siteRef) siteRef.value = this.site.siteId ? this.site.siteId : '';
    },
    updateSite(e) {
      // avoid to update the this.permit.ePermitSite.ownerCompany
      // to null for the manually typed address
      if (e.e || (!e.itemData && !this.company.address && !this.site.siteName)) {
        this.$emit('updateSite', e.itemData);
      } else if (e.itemData && e.itemData.site_Id) {
        // eslint-disable-next-line max-len
        const site = this.siteDataSource.find((x) => x.site_Id === parseInt(e.itemData.site_Id, 0));
        if (!site) {
          this.site.siteId = null;
          e.itemData = null;
          e.value = null;
          e.element.value = null;
        }
      }
    },
  },
};
</script>
